import {ID} from '~/lib/model';


export const biddersLinks = {
    bidders: () => '/bidders',
    bidderCreate: () => '/bidders/create',
    bidderGroups: () => '/bidders/groups',
    bidderGroupCreate: () => '/bidders/groups/create',
    bidderGroup: (groupId: ID) => `/bidders/groups/${groupId}`,
    bidder: (bidderId: ID) => `/bidders/${bidderId}`,
    bidderPreTargetingConfig: (bidderId: ID, preTargetingId: ID) => `/bidders/${bidderId}/pre-targeting/${preTargetingId}`,
    bidderPreTargetingWizard: (bidderId: ID, preTargetingId: ID) => `/bidders/${bidderId}/pre-targeting/${preTargetingId}/wizard`
};